class AlsoBoughtAdd extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.also-bought__add-btn');
    this.hiddenInput = this.querySelector('input[name="variant-id"]');

    if (this.btn) {
      this.btn.addEventListener('click', this.handleAdd.bind(this));
    }
  }

  get variantId() {
    if (this.hiddenInput) return this.hiddenInput.value;
    return null;
  }

  async handleAdd(event) {
    event.preventDefault();
    if (this.classList.contains('loading')) return;
    const variantId = this.variantId;
    if (!variantId) return;

    this.classList.add('loading');
    const cartDrawer = document.querySelector('cart-drawer');

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cartDrawer) {
        formData.append('sections', cartDrawer.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(routes.cart_add_url, config);
      const data = await response.json();

      if (data.status) {
        throw new Error(data.description || 'Failed to add item');
      }

      if (cartDrawer) {
        cartDrawer.renderContents(data);
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'also-bought-add', cartData: data });
    } catch (error) {
      console.error('Also-bought add failed:', error);
    } finally {
      this.classList.remove('loading');
    }
  }
}

customElements.define('also-bought-add', AlsoBoughtAdd);
